import type { ConfigureStoreOptions } from '@reduxjs/toolkit';
import {
  combineReducers,
  configureStore as _configureStore,
} from '@reduxjs/toolkit';

import { appReducer } from './app';
import { modalReducer } from './modal';
import { userReducer } from './user';

const rootReducer = combineReducers({
  app: appReducer,
  user: userReducer,
  modal: modalReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
// v5からPreloadedStateが廃止されたので、RootStateで代用する。より適切な方法があれば変更してください。
// https://redux.js.org/usage/migrations/migrating-rtk-2#preloadedstate-type-removed-in-favour-of-reducer-generic
export type PreloadedState = RootState;

export function configureStore({
  devTools = process.env.NODE_ENV !== 'production',
  middleware = (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: true,
      immutableCheck: false,
      serializableCheck: false,
    }),
  reducer = rootReducer,
  ...rest
}: Partial<ConfigureStoreOptions<RootState>>) {
  return _configureStore({ devTools, middleware, reducer, ...rest });
}

export type AppStore = ReturnType<typeof configureStore>;

// https://redux-toolkit.js.org/usage/usage-with-typescript
// export type AppDispatch = ReturnType<typeof configureStore>['dispatch'];
// export const useAppDispatch: () => AppDispatch = useDispatch;
